module.exports = __webpack_public_path__ + "img/icon-message.8cf6a5cc.png";